export default {
  fetchSettings ({ commit }) {
    this._vm.$network_utils
      .getSettings()
      .then(response => {
        commit('setSettingList', response)
      })
      .catch(error => {
        console.error(error)
      })
  }
}
